<script>
    export default {
        computed: {
            isBot() {
                const botRegex = /bot|googlebot|crawler|spider|robot|crawling/i;
                return navigator.userAgent && botRegex.test(navigator.userAgent);
            }
        },
        render () {
            if (process.server) {
                return null;
            }

            if (this.isBot) {
                return null;
            }

            return this.$scopedSlots.default();
        }
    }
</script>